import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import useTabVisibility from 'hooks/useTabVisibility'
import { fetchAttractionOffers } from 'actions/ExperienceActions'
import { EmptyArray } from 'lib/array/arrayUtils'
import { getAttractionOffersKey } from 'lib/experiences/experienceUtils'

interface UseAttractionOffersResult {
  offerIds: Array<string>
  total: number
  fetching: boolean
  error?: string
}

function useAttractionOffers(attractionId?: string, searchFilters?: Experiences.SearchFilters): UseAttractionOffersResult {
  const dispatch = useAppDispatch()
  const key = attractionId ? getAttractionOffersKey(attractionId, searchFilters) : undefined
  const result = useAppSelector(
    state => key ? state.experience.attractionOffers?.[key] : undefined,
  )

  const isTabActive = useTabVisibility()

  useEffect(() => {
    if (!attractionId || !isTabActive) return
    dispatch(fetchAttractionOffers(attractionId, searchFilters))
    // `key` tracks only API-relevant filter fields (see getAttractionOffersKey)
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- searchFilters identity may change without API impact
  }, [attractionId, key, isTabActive, dispatch])

  return {
    offerIds: result?.offerIds ?? EmptyArray,
    total: result?.total ?? 0,
    fetching: result?.fetching ?? (!!attractionId && !result),
    error: result?.error,
  }
}

export default useAttractionOffers
